import React from 'react';

// tslint:disable:max-line-length
const OverflowButtonHorizontalIcon = (props) => (
  <svg width={1920} height={1920} viewBox="0 0 1920 1920" {...props}>
    <path
      d="M1560 780c99.411 0 180 80.595 180 180 0 99.411-80.595 180-180 180-99.411 0-180-80.595-180-180 0-99.411 80.595-180 180-180zM780 960c0-99.411 80.595-180 180-180 99.411 0 180 80.595 180 180 0 99.411-80.595 180-180 180-99.411 0-180-80.595-180-180zm-600 0c0-99.411 80.595-180 180-180 99.411 0 180 80.595 180 180 0 99.411-80.595 180-180 180-99.411 0-180-80.595-180-180z"
      fillRule="evenodd"
    />
  </svg>
);
// tslint:enable:max-line-length

export default OverflowButtonHorizontalIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/OverflowButtonHorizontalIcon.js